// src/scene/CameraConfig.ts
// Camera configuration — generated by IslandDebug.
// Paste this entire file to replace src/scene/CameraConfig.ts

// ── Main Camera ─────────────────────────────────────────────────────────────────
export const defaultCameraX        = -0.1000;   // World-space X offset of the camera at rest
export const defaultCameraZ        = 1.7800;   // World-space Z position of the camera at rest
export const defaultFov            = 50.5;     // Default camera Field-of-View in degrees (desktop)
export const mobileFov             = 57;       // FOV used when viewport width ≤ mobileBreakpointWidth
export const mobileBreakpointWidth = 768;      // px — widths at or below this are treated as mobile

// ── Scroll Y Limits ───────────────────────────────────────────────────────────
// Higher FOV on mobile means the camera sees more vertically, so the crossing
// band must be pushed further from the surface to avoid seeing through it.
// Scroll moves freely through this band (no snap) — these bounds only feed
// isUnderwater's midpoint (Control.ts), the camera-eye threshold used by
// audio/interaction gating and the render-path branch.
export const aboveWaterBottomY       = 1.0000;  // Desktop: top edge of the crossing band, above water
export const aboveWaterBottomYMobile = 1.4000;  // Mobile: raised because wider FOV reveals surface sooner
export const underwaterTopY          = -1.0000; // Desktop: bottom edge of the crossing band, underwater
export const underwaterTopYMobile    = -1.4000; // Mobile: lowered for the same reason